import { render, staticRenderFns } from "./DoorGroup.vue?vue&type=template&id=318020c2&scoped=true"
import script from "./DoorGroup.vue?vue&type=script&lang=ts"
export * from "./DoorGroup.vue?vue&type=script&lang=ts"
import style0 from "./DoorGroup.vue?vue&type=style&index=0&id=318020c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318020c2",
  null
  
)

export default component.exports